import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { ImagePlus, X } from "lucide-react";

interface UploadImageInputProps {
  onFileChange: (file: File | null) => void;
  buttonText?: string;
}

const UploadImageInput: React.FC<UploadImageInputProps> = ({
  onFileChange,
  buttonText,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
    onFileChange(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    onFileChange(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <Button type="button" onClick={handleButtonClick} variant="outline">
        <ImagePlus className="h-4 w-4 mr-1" />
        {t("input.uploadImage", buttonText || "Upload Image")}
      </Button>
      {selectedFile && (
        <span className="mr-2 inline-flex items-center gap-1 text-sm text-gray-700">
          {selectedFile.name}
          <button
            type="button"
            onClick={handleRemoveFile}
            className="ml-1 p-0.5 rounded hover:bg-gray-200"
          >
            <X size={14} />
          </button>
        </span>
      )}
    </>
  );
};

export default UploadImageInput;
